if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      if (!this.ensureSellingPlan()) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          this.publishAddToCartContext(response, formData);
          window.location = window.routes.cart_url;
          return;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    publishAddToCartContext(response, formData) {
      const payload = this.buildAddToCartContext(response, formData);
      document.dispatchEvent(new CustomEvent('maima:add-to-cart-context', { detail: payload }));
    }

    buildAddToCartContext(response, formData) {
      const sellingPlanId = this.stringValue(formData.get('selling_plan'));
      const variantId = this.stringValue(formData.get('id') || response.variant_id || response.id);
      const quantity = Number(formData.get('quantity') || response.quantity || 1);
      const itemPriceCents = Number(response.final_price || response.price || 0);
      const linePriceCents = Number(response.final_line_price || response.line_price || itemPriceCents * quantity || 0);

      return {
        product_handle: this.form.dataset.productHandle || response.handle || this.productHandleFromUrl(response.url),
        product_id: this.form.dataset.productId || this.stringValue(response.product_id),
        product_title: this.form.dataset.productTitle || response.product_title || '',
        variant_id: variantId,
        variant_title: response.variant_title || '',
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        purchase_option: this.readPurchaseOption(formData, sellingPlanId),
        selling_plan_id: sellingPlanId,
        currency: 'JPY',
        item_price: itemPriceCents / 100,
        item_price_cents: itemPriceCents,
        item_value: linePriceCents / 100,
        item_value_cents: linePriceCents,
        cta_location: this.submitButton ? this.submitButton.getAttribute('data-ga-location') || '' : ''
      };
    }

    readPurchaseOption(formData, sellingPlanId) {
      if (sellingPlanId) return 'subscription';

      const explicit = this.form.dataset.purchaseOption;
      if (explicit === 'subscription' || explicit === 'one-time') return explicit;

      const selectedPurchaseOption = document.querySelector('input[name="purchase_option"]:checked');
      if (selectedPurchaseOption) {
        return selectedPurchaseOption.value === 'one-time' ? 'one-time' : 'subscription';
      }

      if (this.form.dataset.requiresSellingPlan === 'true') return 'subscription';
      if ((this.form.dataset.productHandle || '').indexOf('subscription_') === 0) return 'subscription';

      return 'one-time';
    }

    productHandleFromUrl(url) {
      if (!url) return '';
      const match = String(url).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }

    stringValue(value) {
      return value == null ? '' : String(value);
    }

    ensureSellingPlan() {
      if (this.form.dataset.requiresSellingPlan !== 'true') return true;

      const formData = new FormData(this.form);
      if (formData.get('selling_plan')) return true;

      const defaultSellingPlanId = this.form.dataset.defaultSellingPlanId;
      if (!defaultSellingPlanId) {
        this.handleErrorMessage('定期購入の設定を読み込み中です。数秒後に再度お試しください。');
        return false;
      }

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.value = defaultSellingPlanId;
      input.dataset.maimaDefaultSellingPlan = 'true';
      this.form.appendChild(input);
      return true;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
